var map = {
	"./ai.svg": 5288,
	"./angular.svg": 7688,
	"./aog.svg": 9873,
	"./bootstrap.svg": 8496,
	"./css.svg": 3520,
	"./dialogflow.svg": 9362,
	"./express.svg": 6752,
	"./firebase.svg": 2722,
	"./gcp.svg": 9712,
	"./github.svg": 5552,
	"./html.svg": 6668,
	"./js.svg": 8768,
	"./mongodb.svg": 5409,
	"./node.svg": 6059,
	"./photoshop.svg": 4001,
	"./pwa.svg": 6282,
	"./vue.svg": 2496,
	"./vuetify.svg": 8657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4490;